import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router'

import { ProfileRouteParams } from 'components/paths'
import { SmallPrimaryButton } from 'components/presentational/button'
import {
  storeFrontGiftsPath,
  storeFrontUserPath,
  vipPresentPath,
} from 'components/storefront/StoreFront.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const PresentVipStoreFrontButton: FC = () => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  const { userId } = useParams<ProfileRouteParams>()
  const { baseUrl } = useLayoutContext()
  const authorizationPath = useAuthorizationPath()

  const url = authorized
    ? mergeAllUrls(
        baseUrl,
        storeFrontGiftsPath,
        storeFrontUserPath,
        userId,
        vipPresentPath
      )
    : authorizationPath

  return (
    <div>
      <SmallPrimaryButton to={url}>
        <FormattedMessage
          id="present.vip"
          defaultMessage="Продлите VIP-статус"
        />
      </SmallPrimaryButton>
    </div>
  )
}
